import axios from 'axios'
import $ from 'jquery'
import Vue from 'vue'
import '../bus.js'

// Axios參數
const service = axios.create({
  timeout: 60000 // 請求超時 30秒
})

// 引用彈跳訊息框
var Event = new Vue()
const tip = msg => {
  Event.$bus.$emit('Modals', msg)
}

// 抓取後台權限
var AD = sessionStorage.getItem('BackendPrivilege')
// Response 錯誤代碼判斷
const errorHandle = ststus => {
  switch (ststus) {
    case 400:
      tip('傳送錯誤資料，請重新確認輸入資訊。')
      $('#CheckError').modal('show')
      break
    case 403:
      tip('權限不足')
      $('#CheckError').modal('show')
      break
    case 404:
      tip('出問題了!找不到網頁')
      $('#CheckError').modal('show')
      break
  }
}

// API-Request攔截
service.interceptors.request.use(
  data => {
    Event.$bus.$emit('Loading', true)
    // 防呆API必要資訊
    if (data.data === null) {
      Event.$bus.$emit('Loading', false)
      if (AD) {
        Event.$bus.$emit('ALogOutCheckUser', 'false')
      } else {
        Event.$bus.$emit('LogOutCheckUser', 'false')
      }
      return false
    }
    return data
  },
  error => {
    // 請求錯誤資訊
    tip(error)
    $('#CheckError').modal('show')
  }
)

// API-Response攔截
service.interceptors.response.use(
  res => {
    // 成功請求到資料
    Event.$bus.$emit('Loading', false)
    // 回傳正確資料
    if (res.status === 200) {
      var Ec = res.data.ErrorCode
      var line = res.data.returnCode
      if (Ec === 0) {
        return res.data
      } else if (Ec === 41474 || Ec === 41475 || Ec === 41476 || Ec === 41479 || Ec === 65535) {
        tip(res.data.Msg)
        if (AD) {
          Event.$bus.$emit('ALogOutCheckUser', 'false')
        } else {
          Event.$bus.$emit('LogOutCheckUser', 'false')
        }
      } else if (Ec === 65533) {
        // 查詢無資料
        tip(res.data.Msg)
      } else {
        tip(res.data.Msg)
      }
      if (line) {
        if (line === '0000') {
          return res.data
        } else if (line !== '0000') {
          tip(res.data.returnMessage)
        }
      }
    } else {
      tip(res.data.Msg)
    }
    $('#CheckError').modal('show')
  },
  error => {
    // Response錯誤資訊
    const { Response } = error
    Event.$bus.$emit('Loading', false)
    if (Response) {
      // 成功請求並有接收resp, 但有error資訊
      // 傳送error 狀態代碼
      errorHandle(Response.status)
    } else {
      tip('伺服器無回應，請聯絡網站管理員。')
      $('#CheckError').modal('show')
    }
  }
)

export default service
